import type { QueryClient } from '@tanstack/react-query';
import {
  applyConversationDocumentPatch,
  getCallConversationPatch,
} from 'src/modules/shared/communications/utils/cache/funnel-conversations/realtime-update.util';
import { applyCallTimelineItemUpdate } from 'src/modules/shared/communications/utils/cache/timeline-items/update.util';
import type { CommunicationsRealtimeCallPayload } from '../../types/realtime.types';

/**
 * Applies a validated realtime call payload to owned caches.
 *
 * @param queryClient - React Query client that owns the Communications caches.
 * @param payload - Validated call realtime payload.
 */
export const applyCallRealtimePayload = (
  queryClient: QueryClient,
  payload: CommunicationsRealtimeCallPayload
): void => {
  applyCallTimelineItemUpdate({
    queryClient,
    call: payload.resource,
    action: payload.action,
    funnelId: payload.funnelId,
  });

  applyConversationDocumentPatch({
    queryClient,
    funnelConversationId: payload.funnelConversationId,
    action: payload.action,
    patch: getCallConversationPatch(payload.resource),
  });
};
